import { render } from "./SubscriptionItem.vue?vue&type=template&id=62c91c64&scoped=true"
import script from "./SubscriptionItem.vue?vue&type=script&lang=js"
export * from "./SubscriptionItem.vue?vue&type=script&lang=js"

import "./SubscriptionItem.vue?vue&type=style&index=0&id=62c91c64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c91c64"]])

export default __exports__